import React, { useState, useEffect, useMemo } from "react";
import { BsArrowUpRight } from "react-icons/bs";
import { Button } from 'react-bootstrap';
import MachineModal from '../modal/MachineModal';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import IndividualMachineStatusModal from '../modal/IndividualMachineStatusModal'
import ManpowerAllocationModal from '../modal/ManpowerAllocationModal'
import OperatorPerformamceModal from '../modal/OperatorPerformamceModal'
import MachineMaintenanceModal from '../modal/MachineMaintenanceModal'
import Select from "react-select";
import config from "../../config/config";
import Loader from "../loader/Loader";
import axios from "axios";
import { toast } from 'react-toastify';
import { getAuthToken } from "../../utils/token";
import { formatDate } from '../../utils/formatDate';
import TrainingScheduleNew from "../modal/TrainingScheduleNew";
import DataTable from "react-data-table-component";
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
    },
  },
};
const getStatusBadge = (status) => {
  const statusMap = {
    "Running": "success",
    "Idle": "warning",
  };
  return (
    <span className={`badge bg-${statusMap[status] || "secondary"}-subtle text-${statusMap[status] || "secondary"} p-2 `}>
      {status}
    </span>
  );
};
const MachineManpower = () => {
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState('maintenance');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [manpowerAllocation, setManpowerAllocation] = useState(false)
  const [operatorPerformance, setOperatorPerformance] = useState(false)
  const [machineMaintenance, setMachineMaintenance] = useState(false)
  const [trainingScheduleNew, setTrainingScheduleNew] = useState(false)
  const [machineOperator, setMachineOperator] = useState({
    operators: [],
    machines: []
  });
  // const [selectedAssignments, setSelectedAssignments] = useState([]);
  // const [allocations, setAllocations] = useState([]);
  const [assignedoperators, setAssignedoperators] = useState([])
  const [maintenanceList, setMaintenanceList] = useState([])
  const [selectedMaintenanceId, setSelectedMaintenanceId] = useState(null);
  const [manpowerallocation, setManpowerallocation] = useState([])
  const [operatorperList, setOperatorperList] = useState([])
  const [machineStatus, setMachineStatus] = useState([])
  const [machinebreakdownlist, setMachinebreakdownlist] = useState([])
  const [selectedOperatorId, setSelectedOperatorId] = useState(null);
  const [machineId, setMachineId] = useState(null);
  const [machineWiseList, setMachineWiseList] = useState([]);
  const today = new Date().toISOString().slice(0, 10);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [productId, setProductId] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const updatedOptions = useMemo(() => {
    return [{ label: "All", value: 0 }, ...(productOptions || [])];
  }, [productOptions]);
  // const handleCheckboxChange = (operator_id, machine_id, checked) => {
  //   if (checked) {
  //     setSelectedAssignments((prev) => [...prev, { operator_id, machine_id }]);
  //   } else {
  //     setSelectedAssignments((prev) =>
  //       prev.filter(
  //         (item) => !(item.operator_id === operator_id && item.machine_id === machine_id)
  //       )
  //     );
  //   }
  // };
  // const assignOperator = async (operator_id, machine_id) => {
  //   const token = getAuthToken();
  //   if (!token) {
  //     toast.error("Authentication failed");
  //     return;
  //   }
  //   const storedUser = JSON.parse(localStorage.getItem("user"));
  //   const supervisorId = storedUser?.user?.id;
  //   if (!supervisorId) {
  //     toast.error("Supervisor ID not found in localStorage");
  //     return;
  //   }
  //   const payload = {
  //     supervisor_id: supervisorId,
  //     operator_id,
  //     machine_id,
  //   };
  //   try {
  //     const response = await axios.post(
  //       `${config.API}/supervisor/assignoperator`,
  //       payload,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     toast.success(response.data?.message || "Operator assigned successfully");
  //   } catch (error) {
  //     console.error("Error assigning operator:", error.response?.data || error.message);
  //     toast.error(error.response?.data?.message || "Failed to assign operator");
  //   }
  // };
  // const handleEmergencyReallotment = async () => {
  //   if (selectedAssignments.length === 0) {
  //     toast.warning("Please select at least one operator and machine before reallotment");
  //     return;
  //   }
  //   for (let assign of selectedAssignments) {
  //     await assignOperator(assign?.operator_id, assign?.machine_id);
  //   }
  //   setSelectedAssignments([]);
  // };

  useEffect(() => {
    fetchAssignedoperators()
    fetchMachineOperator()
    fetchMaintenanceList()
    fetchManpowerallocation()
    fetchOperatorperformance()
    fetchMachineStatus()
    fetchMachinebreakdownlist()
    getMachineWiseReport()
    fetchProductList()
  }, []);

  const fetchMachineOperator = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/machineuser`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response?.data || { operators: [], machines: [] };
      setMachineOperator(data);
      // setAllocations(
      //   data?.machines?.map(machine => ({
      //     machine_id: machine?.id,
      //     machine_code: machine?.machine_code,
      //     status: machine?.status,
      //     assigned: []
      //   }))
      // );
    } catch (err) {
      console.error("Error fetching machine/operator:", err.message);
      setMachineOperator({ operators: [], machines: [] });
      // setAllocations([]);
    } finally {
      setLoading(false)
    }
  };

  const fetchMachineStatus = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/machinestatusallocation`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setMachineStatus(response?.data || []);
      } else {
        setMachineStatus([]);
      }

    } catch (err) {
      console.error("Error fetching machine status:", err.message);
      setMachineStatus([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchMaintenanceList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/maintenance/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data) {
        setMaintenanceList(response?.data || []);
      } else {
        setMaintenanceList([]);
      }
    } catch (err) {
      console.error("Error fetching newList:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const fetchManpowerallocation = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/manpowerallocation`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data) {
        setManpowerallocation(response?.data || []);
      } else {
        setManpowerallocation([]);
      }
    } catch (err) {
      console.error("Error fetching newList:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const fetchOperatorperformance = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/operatorperformance`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setOperatorperList(response?.data || []);
      } else {
        setOperatorperList([]);
      }
    } catch (err) {
      console.error("Error fetchOperatorperformance:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const fetchMachinebreakdownlist = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/supervisor/machinebreakdownlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data) {
        setMachinebreakdownlist(response?.data?.breakdowns || []);
      } else {
        setMachinebreakdownlist([]);
      }
    } catch (err) {
      console.error("Error fetchOperatorperformance:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const fetchAssignedoperators = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);

      const response = await axios.get(
        `${config.API}/supervisor/assignedoperators`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const operators = response?.data?.assigned_operators || [];
      setAssignedoperators(operators);

    } catch (err) {
      console.error("Error fetching assigned operators:", err);
      setAssignedoperators([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsUp = async (id) => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API}/supervisor/machinebreakupdate/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.message) {
        toast.success(response?.data?.message)
        fetchMachinebreakdownlist();
      }
    } catch (err) {
      console.error("Error:", err.message);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const openModal = (type) => {
    setMode(type);
    setShow(true);
  };

  const Machinebreakdowncolumns = [
    {
      name: "ID",
      selector: (row) => row?.machine?.machine_code,
      sortable: true
    },

    {
      name: "MACHINE",
      selector: (row) => row.machine?.name,
    },
    {
      name: "DATE",
      selector: (row) => formatDate(row.date),
    },

    {
      name: "Time",
      selector: (row) => row.time,
    },
    {
      name: "STATUS",
      cell: (row) => {
        const status = row.status;

        const badgeClass =
          status === "Resolved"
            ? "bg-success-subtle text-success"
            : "bg-danger-subtle text-danger";

        return (
          <span className={`badge ${badgeClass} p-2`}>
            {status}
          </span>
        );
      },
    },
    {
      name: "ACTIONS",
      cell: (row) => {
        if (row.status === "Resolved") {
          return <span className="text-success fs-5">✔</span>;
        }
        return (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => handleMarkAsUp(row.id)}
          >
            Mark as up
          </Button>
        );
      }
    }
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case "Idle":
        return "bg-warning-subtle text-warning";
      case "Running":
        return "bg-success-subtle text-success";
      default:
        return "bg-light text-muted";
    }
  };

  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProductOptions(
        response?.data?.products?.map((plist) => ({
          value: plist.id,
          label: plist.name,
        })) || []
      );
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      setLoading(false);
    }
  };

  const getMachineWiseReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const res = await axios.post(
        `${config.API}/supervisor/machinewisereport`,
        {
          start_date: startDate,
          end_date: endDate,
          product_id: productId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.data?.success) {
        setMachineWiseList(res.data.machines || []);
      }
    } catch (error) {
      console.error("Machine wise report error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleForceLogout = async (item) => {
    const token = getAuthToken();
    if (!token) return;
    const payload = {
      user_id: item?.operator?.id,
      shift: item?.shift,
      date: new Date().toISOString().split("T")[0],
    };
    try {
      const res = await axios.post(
        `${config.API}/supervisor/forcedlogout`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.data?.success) {
        toast.success(res?.data?.message || "Operator force logout successfully");
      } else {
        toast.error(res?.data?.message || "Force logout failed");
      }
    } catch (err) {
      console.log("API Error:", err.response);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };
  const handleRemove = async (item) => {
    const token = getAuthToken();
    if (!token) return;
    const payload = {
      user_id: item?.operator?.id,
      machine: item?.machine?.id,
      date: new Date().toISOString().split("T")[0],
    };
    try {
      const res = await axios.post(
        `${config.API}/supervisor/forcedremove`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.data?.success) {
        toast.success(res?.data?.message || "Operator remove successfully");
      } else {
        toast.error(res?.data?.message || "Remove failed");
      }
    } catch (err) {
      console.log("API Error:", err.response);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  }
  const MachineWiseColumns = [
    {
      name: "Sl.No",
      cell: (row, index) => index + 1,
      width: "50px"
    },
    {
      name: "Machine",
      selector: (row) => row?.machine_code || "-",
      sortable: true
    },
    {
      name: "Name of Person",
      selector: (row) => row?.user?.name || "-"
    },
    {
      name: "Product",
      selector: (row) => row?.product?.name || "-",
      wrap: true
    },
    {
      name: "Target Qty",
      selector: (row) => row?.total_capacity || 0,
      wrap: true
    },
    {
      name: "No. of Heat",
      selector: (row) => row?.total_heats || 0,
      wrap: true
    },
    {
      name: "Shift",
      selector: (row) => row?.shift || 0
    },
    {
      name: "Date",
      selector: (row) => row?.date || "-"
    },
    {
      name: "Produced Qty",
      selector: (row) => row?.total_units || 0,
      wrap: true,
      maxWidth: "100px", // force smaller width
    },
    {
      name: "Rejected Qty",
      selector: (row) => 0,
      wrap: true
    },
    {
      name: "Accepted Qty",
      selector: (row) => row?.accepted_units || 0,
      wrap: true
    },
    {
      name: "Remark",
      selector: () => "Passed",
    }
  ];

  const downloadManpowerPDF = () => {
    if (!assignedoperators || assignedoperators.length === 0) return;

    const doc = new jsPDF();

    doc.text("Manpower Allocation Report", 14, 15);

    const tableRows = assignedoperators.map((item) => [
      item.operator?.name || "N/A",
      item.supporting_users?.map(u => u.supporting_user?.name).join(", ") || "N/A",
      `${item.machine?.name || "N/A"} | ${item.machine?.machine_code || ""}`,
      item.machinesetup?.products?.name || "Not Set",
      item.machinesetup?.dietable?.name || "Not Set",
      item.shift || "-",
      item.machine?.status || "Unknown"
    ]);

    autoTable(doc, {
      startY: 20,
      head: [[
        "Operator",
        "Sub Operator",
        "Machine",
        "Product",
        "Die",
        "Shift",
        "Status"
      ]],
      body: tableRows
    });

    doc.save("Manpower_Allocation_Report.pdf");
  };

  const downloadMachineWisePDF = () => {
    if (!machineWiseList || machineWiseList.length === 0) return;
    const doc = new jsPDF("landscape");
    doc.text("Machine Wise Report", 14, 15);
    const tableRows = machineWiseList.map((item, index) => [
      index + 1,
      item?.machine_code || "-",
      item?.user?.name || "-",
      item?.product?.name || "-",
      item?.total_capacity || 0,
      item?.total_heats || 0,
      item?.shift || "-",
      item?.date || "-",
      item?.total_units || 0,
      0,
      item?.accepted_units || 0,
      "Passed"
    ]);

    autoTable(doc, {
      startY: 20,
      head: [[
        "Sl No",
        "Machine",
        "Name of Person",
        "Product",
        "Target Qty",
        "No. of Heat",
        "Shift",
        "Date",
        "Produced Qty",
        "Rejected Qty",
        "Accepted Qty",
        "Remark"
      ]],
      body: tableRows,
      styles: {
        fontSize: 8
      },
      headStyles: {
        fillColor: [41, 128, 185]
      }
    });

    doc.save("Machine_Wise_Report.pdf");
  };

  return (
    <div className="container-fluid">
      <div className="row g-1 align-items-stretch font_family">
        <div className="col-lg-6 d-flex">
          <div className="card flex-fill shadow-sm h-100 p-3">
            <div className="d-flex justify-content-between align-items-center">
              <strong className="mb-0 fs-4">Machine Status & Allocation</strong>
              <button className="btn btn-dark btn-sm" onClick={() => openModal('breakdown')}>Machine Breakdown Window</button>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div className="table-responsive mt-1" >
                <table className="table align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>MACHINE</th>
                      <th>TYPE</th>
                      <th>STATUS</th>
                      <th>UTILIZATION</th>
                    </tr>
                  </thead>
                  <tbody >
                    {machineStatus?.machine_status_allocation?.length > 0 ? (
                      machineStatus.machine_status_allocation.map((machine, idx) => (
                        <tr key={idx} className="align-middle border-top">
                          <td
                            className="fw-semibold py-4"
                            onClick={() => {
                              setShowModal(true);
                              setMachineId(machine?.machine_id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {machine?.machine?.machine_code} <BsArrowUpRight />
                          </td>

                          <td>{machine?.machine?.type}</td>
                          <td>{getStatusBadge(machine?.machine?.status)}</td>
                          <td style={{ minWidth: "170px" }}>
                            <div className="d-flex align-items-center gap-1">
                              <div className="progress flex-grow-1" style={{ height: "10px" }}>
                                <div
                                  className="progress-bar bg-dark"
                                  style={{ width: `${machine?.avg_utilization}%` }}
                                ></div>
                              </div>
                              <small className="text-nowrap">
                                {Number(machine.avg_utilization).toFixed(2)}%
                              </small>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center fw-semibold py-4 text-muted">
                          Data not found
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
              </div>
            )}

          </div>
        </div>
        <div className="col-lg-6 d-flex">
          <div className="d-flex flex-column w-100 h-100 font_family">
            <div className="card mb-1 shadow-sm flex-fill">
              <div className="d-flex justify-content-between align-items-center p-3">
                <strong className="mb-0 fs-4">Manpower Allocation</strong>
                <button className="btn btn-dark btn-sm" onClick={() => setTrainingScheduleNew(true)}>Training Schedule</button>
              </div>
              <div className="card-body" >
                <p>
                  Operators On Shift:{" "}
                  <strong>
                    {manpowerallocation?.assigned_operator ?? 0}/
                    {manpowerallocation?.present_operator ?? 0}
                  </strong>
                </p>

                <p>
                  Stations Covered:{" "}
                  <strong>
                    {manpowerallocation?.station_occupied ?? 0}/
                    {manpowerallocation?.station ?? 0}
                  </strong>
                </p>

                <p className="mb-0">
                  Utilization:{" "}
                  <strong>
                    {(
                      ((manpowerallocation?.assigned_operator ?? 0) /
                        (manpowerallocation?.present_operator || 1)) *
                      100
                    ).toFixed(2)}
                    %
                  </strong>
                </p>
              </div>
            </div>
            <div className="card shadow-sm flex-fill">
              {loading ? (
                <Loader />
              ) : (
                // <div className="card-body">
                //   <strong className="fs-4 mb-3 d-block">Manpower Allocation</strong>

                //   {allocations?.length > 0 && machineOperator?.operators?.length > 0 ? (
                //     <>
                //       <div className="table-responsive" style={{ maxHeight: "530px", overflowY: "auto" }}>
                //         <table className="table align-middle text-center small">
                //           <thead className="table-light">
                //             <tr className="">
                //               <th className="text-start position-sticky top-0">Machine / Operator</th>
                //               {machineOperator?.operators?.map((operator, index) => (
                //                 <th key={index} className="position-sticky top-0">
                //                   {operator?.name}
                //                   <br />
                //                   <small className="text-muted">({operator?.role})</small>
                //                 </th>
                //               ))}
                //             </tr>
                //           </thead>
                //           <tbody>
                //             {allocations.map((alloc, rowIdx) => (
                //               <tr key={rowIdx}>
                //                 <td className="text-start">
                //                   {alloc?.machine_code}
                //                   <br />
                //                   {getStatusBadge(alloc?.status)}
                //                 </td>
                //                 {machineOperator?.operators?.map((operitem, colIdx) => (
                //                   <td key={colIdx}>
                //                     <Form.Check
                //                       type="checkbox"
                //                       checked={selectedAssignments?.some(
                //                         (item) =>
                //                           item?.operator_id === operitem?.id &&
                //                           item?.machine_id === alloc?.machine_id
                //                       )}
                //                       onChange={(e) =>
                //                         handleCheckboxChange(
                //                           operitem?.id,
                //                           alloc?.machine_id,
                //                           e.target.checked
                //                         )
                //                       }
                //                     />
                //                   </td>
                //                 ))}
                //               </tr>
                //             ))}
                //           </tbody>

                //         </table>
                //       </div>

                //       <div className="d-flex justify-content-end gap-2 mt-3">
                // <button
                //   className="btn btn-outline-secondary btn-sm"
                //   onClick={() => setManpowerAllocation(true)}
                // >
                //   Adjust Allocation
                // </button>
                //         {/* <button
                //           className="btn btn-dark btn-sm"
                //           onClick={handleEmergencyReallotment}
                //         //  onClick={() => setManpowerAllocation(true)}
                //         >
                //           Emergency Reallotment
                //         </button> */}
                //       </div>
                //     </>
                //   ) : (
                //     <div className="text-center text-muted py-4">
                //       No manpower allocation data found
                //     </div>
                //   )}
                // </div>
                <div className="card shadow-sm">
                  <div className="card-body d-flex flex-column" style={{ maxHeight: "600px", overflowY: "auto" }}>
                    <strong className="fs-4 mb-1">Manpower Allocation</strong>
                    <div
                      className="table-responsive flex-grow-1"
                      style={{ maxHeight: "480px", overflowY: "auto" }}
                    >
                      <table className="table  table-hover align-middle">
                        <thead className="table-light sticky-top">
                          <tr>
                            <th>Operator</th>
                            <th>Sub Operator</th>
                            <th>Machine</th>
                            <th>Product</th>
                            <th>Die</th>
                            <th>Shift</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {assignedoperators && assignedoperators.length > 0 ? (
                            assignedoperators.map((item, index) => (
                              <tr key={item.id}>
                                <td>{item.operator?.name || "N/A"}</td>
                                <td className="fs-6">
                                  <div className="d-flex flex-wrap gap-1">
                                    {item.supporting_users?.map((user) => (
                                      <span key={user.id} className="badge bg-success small">
                                        {user.supporting_user?.name}
                                      </span>
                                    ))}
                                  </div>
                                </td>
                                <td>{item.machine?.name || "N/A"} | {item.machine?.machine_code || "N/A"} </td>
                                <td>{item.machinesetup?.products?.name || "Not Set"}</td>
                                <td>{item.machinesetup?.dietable?.name || "Not Set"}</td>
                                <td>{item.shift}</td>
                                <td>
                                  <span className={`badge ${getStatusClass(item?.machine?.status)} p-2`}>
                                    {item?.machine?.status || "Unknown"}
                                  </span>
                                </td>
                                <td>
                                  {item?.machine?.status === "Running" && (
                                    <button className="btn btn-danger py-1 px-2" onClick={() => handleForceLogout(item)}>Force</button>
                                  )}
                                  {item?.machine?.status === "Idle" && (
                                    <button className="btn btn-danger py-1 px-2" onClick={() => handleRemove(item)}>Remove</button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Button Bottom Right */}
                    <div className="mt-auto d-flex justify-content-end gap-1 pt-3">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => setManpowerAllocation(true)}
                      >
                        Adjust Allocation
                      </button>

                      <Button
                        variant="success"
                        size="sm"
                        onClick={downloadManpowerPDF}
                      >
                        Download PDF
                      </Button>
                    </div>

                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
      <div className="row g-1 mt-1">
        <div className="col-lg-6">
          <div className="card h-100 shadow-sm p-3">
            <strong className="mb-1 fs-4">Operator Performance</strong>
            {loading ? (
              <Loader />
            ) : (
              <>
                {operatorperList?.operator_performance?.length > 0 ? (
                  operatorperList?.operator_performance.map((performance, idx) => {
                    const totalProduced = Number(performance?.total_units_produced);
                    const Target = Number(performance?.target);
                    const utilization =
                      Target > 0 ? ((totalProduced / Target) * 100).toFixed(2) : 0;

                    return (
                      <div
                        className="d-flex justify-content-between align-items-center mb-1"
                        key={idx}
                      >
                        <b
                          onClick={() => {
                            setSelectedOperatorId(performance?.user?.id);
                            setOperatorPerformance(true);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {performance?.user?.name} <BsArrowUpRight />
                        </b>
                        <div
                          className="d-flex align-items-center gap-1"
                          style={{ minWidth: "40%" }}
                        >
                          <div className="progress flex-grow-1" style={{ height: "8px" }}>
                            <div
                              className="progress-bar bg-dark"
                              style={{ width: `${utilization}%` }}
                            ></div>
                          </div>
                          <small className="fw-semibold">{utilization}%</small>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center fw-semibold text-muted">Data not found</div>
                )}
              </>


            )}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card h-100 shadow-sm p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <strong className="mb-0 fs-4">Machine Maintenance Schedule</strong>
              <button className="btn btn-dark btn-sm" onClick={() => openModal('maintenance')}>Request Maintenance</button>
            </div>
            {loading ? (
              <Loader />
            ) : (<div className="table-responsive">
              <table className="table table-sm text-nowrap align-middle">
                <thead className="table-light">
                  <tr>
                    <th>MACHINE</th>
                    <th>STATUS</th>
                    <th>DATE</th>
                  </tr>
                </thead>
                <tbody>
                  {maintenanceList?.maintenance_requests &&
                    maintenanceList.maintenance_requests.length > 0 ? (
                    maintenanceList.maintenance_requests.map((maintenance, idx) => (
                      <tr key={idx}>
                        <td
                          onClick={() => {
                            setMachineMaintenance(true);
                            setSelectedMaintenanceId(maintenance.id);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {maintenance?.machine?.machine_code} <BsArrowUpRight />
                        </td>
                        <td>
                          <span
                            className={`badge p-2 ${maintenance?.status?.toLowerCase() === "success"
                              ? "bg-success-subtle text-success"
                              : maintenance?.status?.toLowerCase() === "pending"
                                ? "bg-warning-subtle text-warning"
                                : maintenance?.status?.toLowerCase() === "rejected"
                                  ? "bg-danger-subtle text-danger"
                                  : maintenance?.status?.toLowerCase() === "scheduled"
                                    ? "bg-primary-subtle text-primary"
                                    : "bg-secondary-subtle text-secondary"
                              }`}
                          >
                            {maintenance?.status || "Request Maintenance"}
                          </span>
                        </td>
                        <td>{formatDate(maintenance.maintenance_date)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center text-muted py-3">
                        No maintenance requests found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>)}
          </div>
        </div>
      </div>

      <div className="row mt-1 m-1">
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <strong className="fs-4">Machine Breakdown Window</strong>
          </div>
          {
            loading ? (
              <Loader />
            ) : (
              <DataTable
                columns={Machinebreakdowncolumns}
                customStyles={customStyles}
                data={machinebreakdownlist}
                responsive
                striped
                highlightOnHover
              />
            )
          }
        </div>
      </div>

      <div className="row mt-1 m-1">
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <strong className="fs-4">Machine Wise Report</strong>
            <div className="d-flex gap-2">
              <input
                type="date"
                className="form-control"
                style={{ width: "170px" }}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <input
                type="date"
                className="form-control"
                style={{ width: "170px" }}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <div style={{ width: 300 }}>
                <Select
                  options={updatedOptions}
                  placeholder="Select Product"
                  value={updatedOptions.find((opt) => opt.value === productId)}
                  onChange={(selectedOption) =>
                    setProductId(selectedOption ? selectedOption.value : 0)
                  }
                  isClearable
                />
              </div>
              <button
                className="btn btn-primary"
                onClick={getMachineWiseReport}
              >
                Filter
              </button>
              <Button
                variant="success"
                size="sm"
                onClick={downloadMachineWisePDF}
              >
                Download PDF
              </Button>

            </div>
          </div>
          {
            loading ? (
              <Loader />
            ) : (
              <DataTable
                columns={MachineWiseColumns}
                data={machineWiseList}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                noDataComponent={
                  <div style={{ padding: "20px", fontSize: "15px", color: "#888" }}>
                    No Machine Report Found
                  </div>
                }
              />
            )
          }

        </div>
      </div>

      {/*  Machine Modal */}
      <MachineModal
        show={show}
        onMaintenance={fetchMaintenanceList}
        onBreakdown={fetchMachinebreakdownlist}
        handleClose={() => setShow(false)} mode={mode}
      />
      {/* IndividualMachineStatusModal */}
      <IndividualMachineStatusModal
        show={showModal}
        machineId={machineId}
        handleClose={() => setShowModal(false)}
      />
      {/* ManpowerAllocationModal */}
      <ManpowerAllocationModal
        show={manpowerAllocation}
        handleClose={() => setManpowerAllocation(false)}
        machineOperator={machineOperator}
      />
      {/* OperatorPerformamceModal */}
      <OperatorPerformamceModal
        show={operatorPerformance}
        handleClose={() => setOperatorPerformance(false)}
        operatorId={selectedOperatorId}
      />
      {/* MachineMaintenanceModal */}
      <MachineMaintenanceModal
        show={machineMaintenance}
        maintenanceId={selectedMaintenanceId}
        handleClose={() => setMachineMaintenance(false)}
      />
      {/* TrainingScheduleNew */}
      <TrainingScheduleNew
        show={trainingScheduleNew}
        handleClose={() => setTrainingScheduleNew(false)}
      />
    </div>
  );
};
export default MachineManpower;

